<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
  <div class="post-login-1-col-2 pt-70-pb-70-pr-40 p-mobile-15">
    <div class="onboarding-canvas h-500">
      <grid-row class="justify-content-center align-content-between h-100">
        <grid-col col="12">
          <grid-row class="mt-30 align-item-center col-space">
            <grid-col col="auto" mobile="3">
            </grid-col>
            <grid-col col="auto" mobile="9">
              <div class="font-400 font-size-20px line-h-25">
                <span>
                  {{ "Enter4digitcode" | translate }}
                </span>
                <br>
                <span class="color-primary" *ngIf="this.auth?.RegisteredUser == undefined">
                  {{this.mobilemask}}
                </span>
                <span class="color-primary" *ngIf="this.auth?.RegisteredUser != undefined">
                  {{this.CommonService.maskMobileNumber(this.auth?.RegisteredUser?.mobile)|translate}}
                </span>
              </div>
            </grid-col>
          </grid-row>
        </grid-col>
        <grid-col col="12">
          <div class="mt-50 form-group">
            <ng-otp-input (onInputChange)="onOtpChange($event)"  (keydown)="onKeyDown($event)" allowNumbersOnly='true'
              [config]="{length:4,allowNumbersOnly:true,isPasswordInput:true}"></ng-otp-input>
          </div>
          <grid-row class="justify-content-center align-item-center mt-50">
            <grid-col col="auto" *ngIf="!OptTimerbtnShow">
              <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="ResendOtp()">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                  {{ "Resend" | translate }}
                </div>
              </div>
            </grid-col>
            <grid-col col="auto" *ngIf="OptTimerbtnShow">
              <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                  {{ "Resend" | translate }}
                  <span *ngIf="true" class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
              </div>
            </grid-col>
          </grid-row>
        </grid-col>
        <grid-col col="12">
          <grid-row class="mt-50 mb-30">
            <grid-col col="12" *ngIf="(this.NewEMail == undefined || this.NewEMail == '') &&(this.NewMOb== undefined || this.NewMOb == '' )">
              <button class="btn-dft mt-20" (click)="Next()" [disabled]="isValid()">
                {{ "Verify" | translate }}
              </button>

            </grid-col>
            <grid-col col="12" *ngIf="(this.NewEMail != undefined && this.NewEMail != '') || ( this.NewMOb != undefined && this.NewMOb!= '' ) ">
              <button class="btn-dft mt-20" (click)="Next()" [disabled]="isValid()">
                {{ "Next" | translate }}
              </button>

            </grid-col>
          </grid-row>
          
        </grid-col>
      </grid-row>
    </div>
  </div>
  <!-- <div class="post-login-1-col-3">
    <div class="pl-20 pr-20">
      <div class="font-400 font-size-14px line-h-20 color-base-1500 mt-14 letter-spacing-1 mb-10">
        {{"Sponsored" | translate }}
      </div>
      <div class="deal-card pt-10 pb-10">
        <div class="card-img">
          <img src="~/../assets/images/heath-coverage-img.jpg" alt="">
        </div>
        <div class="content-box bg-2900">
          <div class="font-600 font-size-14px line-h-20 color-base-1500">
            {{"NeedMedicalInsurance" | translate }}
          </div>
          <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
            {{"GetYourFamilyMedical" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>


<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="CONTINUE"
  [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="continue()">
  <div class="text-align-center">
    <ng-icon iconClass="icon-mobile-otp" width="72" height="72"></ng-icon>
    <div class="font-size-20px font-400 line-h-25 mt-30">
      {{ "ChangeMobileNum" | translate }}
    </div>
    <div class="color-base-400 font-size-14px line-h-25 mt-10">
      {{ "Forsecuritymeasure" | translate }}
    </div>
  </div>
</modal>
